import { Link } from "@tanstack/react-router";
import { useLocale } from "@/lib/i18n";
import { Logo } from "@/components/site/Logo";
import { PRIVACY_SETTINGS_EVENT } from "@/lib/consent";

export function SiteFooter() {
  const locale = useLocale();
  const t = locale === "es"
    ? {
        tagline: "Shopify Select Partner desde 2015. Construimos y escalamos tiendas Shopify y Shopify Plus para marcas DTC establecidas en EE. UU. y Latam.",
        services: "Servicios",
        company: "Compañía",
        legal: "Legal",
        contact: "Contacto",
        offices: "Presencia del equipo",
        network: "Red global",
        rights: "Todos los derechos reservados.",
        privacyChoices: "Opciones de privacidad",
        items: {
          services: [
            { label: "Desarrollo Shopify", to: "/es/desarrollo-shopify" },
            { label: "Contratar Desarrollador Shopify", to: "/es/contratar-desarrollador-shopify" },
            { label: "Migración a Shopify", to: "/es/migracion-shopify" },
            { label: "Agencia Shopify Plus", to: "/es/agencia-shopify-plus" },
            { label: "Rendimiento Shopify", to: "/es/rendimiento" },
            { label: "CRO Shopify", to: "/es/cro-shopify" },
            { label: "SEO Técnico Shopify", to: "/es/seo-tecnico-shopify" },
            { label: "Auditoría GEO", to: "/geo-readiness" },
            { label: "Analítica & IA Shopify", to: "/es/analitica-ai" },
            { label: "PULSE", to: "/es/pulse" },
          ],
          company: [
            { label: "Nosotros", to: "/es/nosotros" },
            { label: "Confianza y procurement", to: "/es/confianza" },
            { label: "Partners de referidos", to: "/es/partners/referidos" },
            { label: "Proyectos", to: "/es/proyectos" },
            { label: "Precios", to: "/es/precios" },
            { label: "Recursos", to: "/es/recursos" },
          ],
          legal: [
            { label: "Privacidad", to: "/es/privacidad" },
            { label: "Términos", to: "/es/terminos" },
            { label: "Términos de referidos", to: "/es/partners/terminos-referidos" },
          ],
          accessibility: {
            label: "Declaración de accesibilidad",
            href: "https://dashboard.accessibe.com/app/statement?license=6453c13e04bd1e000347edc7",
          },
        },
      }
    : {
        tagline: "Shopify Select Partner since 2015. We build and scale Shopify and Shopify Plus stores for established DTC brands across the USA and Latam.",
        services: "Services",
        company: "Company",
        legal: "Legal",
        contact: "Contact",
        offices: "Team footprint",
        network: "Global network",
        rights: "All rights reserved.",
        privacyChoices: "Privacy choices",
        items: {
          services: [
            { label: "Shopify Development Agency", to: "/shopify-experts" },
            { label: "Hire a Shopify Developer", to: "/hire-shopify-developer" },
            { label: "Shopify Migration", to: "/shopify-migration" },
            { label: "Shopify Plus Agency", to: "/shopify-plus-agency" },
            { label: "Shopify Performance", to: "/shopify-performance" },
            { label: "Shopify CRO", to: "/shopify-cro" },
            { label: "Shopify Technical SEO", to: "/shopify-technical-seo" },
            { label: "Shopify Analytics & AI", to: "/analytics-ai" },
            { label: "GEO Readiness Audit", to: "/geo-readiness" },
            { label: "PULSE", to: "/pulse" },
          ],
          company: [
            { label: "About", to: "/about" },
            { label: "Trust and procurement", to: "/trust" },
            { label: "Technology partners", to: "/partners" },
            { label: "Referral partners", to: "/partners/referrals" },
            { label: "Work", to: "/work" },
            { label: "Pricing", to: "/pricing" },
            { label: "Resources", to: "/resources" },
            { label: "Insights", to: "/blog" },
          ],
          legal: [
            { label: "Privacy", to: "/privacy" },
            { label: "Terms", to: "/terms" },
            { label: "Referral program terms", to: "/partners/referral-terms" },
          ],
          accessibility: {
            label: "Accessibility Statement",
            href: "https://dashboard.accessibe.com/app/statement?license=6453c13e04bd1e000347edc7",
          },
        },
      };

  return (
    <footer data-surface="dark" className="border-t border-[rgb(250_250_248/14%)] bg-[#0a0a0a] text-[#fafaf8]">
      <div className="mx-auto max-w-7xl px-6 py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Link to={locale === "es" ? "/es" : "/"} className="inline-flex items-center" aria-label="Shugert, home">
              <Logo tone="light" className="h-16 w-auto md:h-20" />
            </Link>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-[#fafaf8]/60">
              {t.tagline}
            </p>
            <p className="mt-8 text-xs uppercase tracking-[0.2em] text-[#fafaf8]/60">
              {t.offices}
            </p>
            <ul className="mt-3 grid grid-cols-1 gap-1 text-sm text-[#fafaf8]/60 sm:grid-cols-3">
              <li>Hermosillo, MX</li>
              <li>Barcelona, ES</li>
              <li>New York, US</li>
            </ul>

            <div className="mt-8 border-t border-[rgb(250_250_248/14%)] pt-6">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#fafaf8] font-mono">
                {t.network}
              </p>
              <nav className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2" aria-label={t.network}>
                <a
                  href="https://shugertmarketing.com/"
                  className="text-sm text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
                >
                  Shugert USA
                </a>
                <a
                  href="https://shugert.es/"
                  className="text-sm text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
                >
                  Shugert España
                </a>
                <a
                  href="https://taskerarmy.com/"
                  className="text-sm text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
                >
                  TaskerArmy
                </a>
              </nav>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#fafaf8] font-mono">
              {t.services}
            </h2>
            <ul className="mt-4 space-y-3">
              {t.items.services.map((i) => (
                <li key={i.to}>
                  <Link
                    to={i.to}
                    className="text-sm text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
                  >
                    {i.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#fafaf8] font-mono">
              {t.company}
            </h2>
            <ul className="mt-4 space-y-3">
              {t.items.company.map((i) => (
                <li key={i.to}>
                  <Link
                    to={i.to}
                    className="text-sm text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
                  >
                    {i.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#fafaf8] font-mono">
              {t.contact}
            </h2>
            <ul className="mt-4 space-y-3 text-sm text-[#fafaf8]/60">
              <li>
                <a
                  href="mailto:hello@shugert.com.mx"
                  className="transition-colors hover:text-[#ccff00]"
                >
                  hello@shugert.com.mx
                </a>
              </li>
              <li>
                <Link
                  to={locale === "es" ? "/es/cotizacion" : "/get-a-quote"}
                  className="transition-colors hover:text-[#ccff00]"
                >
                  {locale === "es" ? "Solicitar cotización" : "Request a quote"}
                </Link>
              </li>
            </ul>
            <h2 className="mt-8 text-xs font-semibold uppercase tracking-[0.2em] text-[#fafaf8] font-mono">
              {t.legal}
            </h2>
            <ul className="mt-4 space-y-3">
              {t.items.legal.map((i) => (
                <li key={i.to}>
                  <Link
                    to={i.to}
                    className="text-sm text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
                  >
                    {i.label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  type="button"
                  onClick={() => window.dispatchEvent(new Event(PRIVACY_SETTINGS_EVENT))}
                  className="text-sm text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
                >
                  {t.privacyChoices}
                </button>
              </li>
              <li>
                <a
                  href={t.items.accessibility.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-sm text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
                >
                  {t.items.accessibility.label}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-[rgb(250_250_248/14%)] pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-[#fafaf8]/60">
            © <time dateTime={String(new Date().getFullYear())}>{new Date().getFullYear()}</time> Shugert. {t.rights}
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <p className="text-xs text-[#fafaf8]/60">
              {locale === "es" ? "Hecho con cuidado en MX · ES · US" : "Crafted with care in MX · ES · US"}
            </p>
            <Link
              to="/portal"
              className="text-xs text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
            >
              {locale === "es" ? "Portal de cliente" : "Client portal"}
            </Link>
            <Link
              to="/partner-login"
              className="text-xs text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
            >
              {locale === "es" ? "Portal de partners" : "Partner portal"}
            </Link>
            <Link
              to="/agency-login"
              className="text-xs text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
            >
              {locale === "es" ? "Acceso para agencias" : "Agency login"}
            </Link>
            <Link
              to="/admin"
              className="text-xs text-[#fafaf8]/60 transition-colors hover:text-[#ccff00]"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}